import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setVideoRecord } from "@data/redux/actions/camera"
import { useNavigation } from "@react-navigation/native"
import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react"
import { View } from "react-native"
import { connect } from "react-redux"
import Webcam from "react-webcam"

const VideoRecordingComponent = (props) => {
    const { setRecordingStarted, answerDuration, testMode = false } = props

    const webcamRef = useRef(null)
    const mediaRecorderRef = useRef(null)
    const [recordedChunks, setRecordedChunks] = useState([])

    const [permissionGranted, setPermissionGranted] = useState(false)

    const mimeType = MediaRecorder.isTypeSupported("video/webm")
        ? "video/webm"
        : "video/mp4"

    const checkMediaAccess = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
            })
            setPermissionGranted(true)
            stream.getTracks().forEach((track) => track.stop())
            return true
        } catch (error) {
            setPermissionGranted(false)
            return false
        }
    }

    useEffect(() => {
        checkMediaAccess()
    }, [])

    const handleStartCaptureClick = useCallback(() => {
        if (webcamRef.current?.stream) {
            setRecordingStarted(true)
            mediaRecorderRef.current = new MediaRecorder(
                webcamRef?.current?.stream,
                {
                    mimeType,
                }
            )

            mediaRecorderRef.current.addEventListener(
                "dataavailable",
                handleDataAvailable
            )

            mediaRecorderRef.current.addEventListener(
                "error",
                handleMediaRecorderError
            )

            console.log("STARTING RECORDING")
            mediaRecorderRef.current.start()
        }
    }, [webcamRef, mediaRecorderRef, webcamRef.current?.stream])

    const handleDataAvailable = useCallback(
        (data) => {
            if (data.data.size > 0) {
                setRecordedChunks((prev) => prev.concat(data.data))
            }
        },
        [setRecordedChunks]
    )

    const handleMediaRecorderError = useCallback(
        (event) => {
            console.log("ERREUR MEDIA RECORDER", event.error)
        },
        [mediaRecorderRef, webcamRef]
    )

    const handleStopCaptureClick = useCallback(() => {
        if (
            mediaRecorderRef.current?.state === "recording" ||
            mediaRecorderRef.current?.state === "paused"
        )
            mediaRecorderRef.current?.stop()

        setRecordingStarted(false)
    }, [mediaRecorderRef, webcamRef])

    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()

    useEffect(() => {
        if (webcamRef && permissionGranted && !testMode) {
            setTimeout(() => {
                handleStartCaptureClick()
            }, 2000)
        }
    }, [webcamRef, permissionGranted])
    useEffect(() => {
        if (props.videoRecord && !testMode) {
            navigation?.goBack()
        }
    }, [props.videoRecord])

    useEffect(() => {
        if (answerDuration < 1 && !testMode && !props.videoRecord) {
            handleStopCaptureClick()
            setRecordingStarted(false)
            if (recordedChunks.length) {
                const blob = new Blob(recordedChunks, {
                    type: mimeType,
                })
                let url = URL.createObjectURL(blob)
                let file = new File(
                    [blob],
                    "testName." + mimeType?.split("/")?.[1],
                    { type: mimeType }
                )
                props.setVideoRecord({ ...file, uri: url })
                setRecordedChunks([])
            }
        }
    }, [answerDuration, recordedChunks])

    return (
        <View style={{ flex: 1, justifyContent: "center" }}>
            <Webcam
                audio={true}
                ref={webcamRef}
                height={dimensions?.height}
                mirrored={true}
                muted={true}
            />
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        testQuestions: state.data.tutors?.testQuestions,
        videoRecord: state.camera?.videoRecord,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setVideoRecord,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoRecordingComponent)
